import { Modal } from "antd";
import "../../styles/AIInsightModal.css";
import {
  CloseOutlined,
  ExclamationOutlined,
  CheckOutlined,
  InfoOutlined,
} from "@ant-design/icons";
import { useFetchFunction } from "../../utils/hooks/UseFetchUrl";
import { useEffect } from "react";

const defaultFindings = [
  {
    id: 1,
    type: "critical",
    title: "Key Gaps",
    description:
      "Website lead submission failed and the first attempt received no callback.",
  },
  {
    id: 2,
    type: "warning",
    title: "What worked",
    description:
      "Project information was not communicated adequately and a site visit was not effectively offered.",
  },
  {
    id: 3,
    type: "success",
    title: "Key Risk",
    description:
      "Showroom experience, product knowledge and sales presentation were strong.",
  },
  {
    id: 4,
    type: "warning",
    title: "Priority Action",
    description:
      "Different sales executives provided differing levels of project information.",
  },
];

const iconMap = {
  critical: <ExclamationOutlined />,
  warning: <ExclamationOutlined />,
  success: <CheckOutlined />,
  info: <InfoOutlined />,
};

const AIInsightModal = ({ open, onClose, overallScore = 0, auditStoreId }) => {
  const { loading, data, getData } = useFetchFunction();

  useEffect(() => {
    if (!open || !auditStoreId) return;

    getData(`client/sentiment_data/${auditStoreId}`);
  }, [open, auditStoreId]);

  const quickInsight = data?.quick_insight || "No quick insight available.";

  return (
    <Modal
      className="ai-insight-modal"
      open={open}
      onCancel={onClose}
      footer={null}
      closable={false}
      width={450}
      loading={loading}
    >
      <div className="ai-insight-header">
        <div className="ai-insight-title-wrap">
          <div className="rbAiBtn">
            <span className="geminiSparkle">✦</span>
          </div>
          <h3 className="ai-insight-title">AI Insight</h3>
        </div>
        <button className="ai-insight-close-btn" onClick={onClose}>
          <CloseOutlined />
        </button>
      </div>
      <div className="ai-insight-divider" />

      <div className="ai-insight-sub-header">
        <div className="ai-insight-meta-row">
          <span className="code">{data?.[0]?.audit?.store?.code ?? "N/A"}</span>
          <span className="sep">|</span>
          <span className="dealer">
            {data?.[0]?.audit?.store?.name ?? "N/A"}
          </span>
        </div>
        <div className="ai-insight-score-row">
          <span className="label">Overall Score</span>
          <span className="ai-insight-score-badge">{overallScore}%</span>
        </div>
      </div>

      <div className="ai-insight-section-heading">Quick Insight</div>
      <p className="ai-insight-paragraph">{quickInsight}</p>

      <div className="ai-insight-divider" />

      <div className="ai-insight-section-heading">Key Findings</div>
      <div className="ai-insight-findings-list">
        {defaultFindings.map((f) => (
          <div className="ai-insight-finding-item" key={f.id}>
            <div className={`ai-insight-icon-wrap ${f.type}`}>
              {iconMap[f.type]}
            </div>
            <div className="ai-insight-finding-text">
              <div className="ai-insight-finding-title">{f.title}</div>
              <div className="ai-insight-finding-desc">{f.description}</div>
            </div>
          </div>
        ))}
      </div>
    </Modal>
  );
};

export default AIInsightModal;
